export const nationality = [
  { label: "中国", value: "0" },
  { label: "美国", value: "1" },
  { label: "日本", value: "2" },
  { label: "韩国", value: "3" },
  { label: "巴西", value: "4" },
  { label: "英国", value: "5" },
];

export const useStatus = [
  { label: "冻结", value: "3" },
  { label: "停用", value: "2" },
  { label: "正在使用", value: "1" },
];

// 退款类型
export const payState = [
  { label: "1688付款", value: "1" },
  { label: "1688退款", value: "2" },
  { label: "淘宝付款", value: "3" },
  { label: "淘宝退款", value: "4" },
];
// 当前月
export const getCurrentMonth = () => {
  var date = new Date();
  date.setDate(1);
  var month = parseInt(date.getMonth() + 1);
  var day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }

  return date.getFullYear() + "-" + month;
};

export const formatDateCommon = (v) => {
  if (!v) {
    return "";
  }

  var str = v.substr(0, v.length - 8);
  str =
    str.substr(0, 4) +
    "年" +
    str.substr(4, 2) +
    "月" +
    str.substr(6, 2) +
    "日" +
    str.substr(8, 2) +
    "时" +
    str.substr(10, 2) +
    "分" +
    str.substr(12, 2) +
    "秒";
  return str;
};
export const apply_type = [
  {
    label: "付款申请",
    value: 1,
  },
  {
    label: "差旅费申请",
    value: 2,
  },
  {
    label: "采购申请",
    value: 3,
  },
  {
    label: "费用申请",
    value: 4,
  },
];
